<template>
    <li>
        <div class="flex items-center pb-1-1 text-slate-300 hover:bg-white/10 hover:text-ui-active transition-colors"
             :class="{ 'bg-white/15 ring-2 ring-ui-active text-ui-active': isDragOver }"
             @dragover="onDragOver" 
             @drop="onDrop"
             @dragenter="onDragEnter"
             @dragleave="onDragLeave">
            <span v-if="hasChildren" @click="$emit('toggle', node.id)" class="cursor-pointer select-none mr-1">
                <span v-if="expanded.has(node.id)">-</span>
                <span v-else>+</span>
            </span>
            <span v-else class="w-3 inline-block"></span>
            <span class="w-full" @click="$emit('select', node)"
                :class="{ 'font-bold': selectedLabelId === node.id, 'cursor-pointer': true }" :draggable="editable"
                @dragstart="onDragStart">
                {{ node.name }}
            </span>
            <button class="text-xs text-red-600 ml-2" @click.stop="onDeleteLabel">x</button>
        </div>
        <ul v-if="hasChildren && expanded.has(node.id)" class="pl-4">
            <LabelTreeNode v-for="child in node.children" :key="child.id" :node="child" :expanded="expanded"
                :selectedLabelId="selectedLabelId" :editable="editable" @toggle="$emit('toggle', $event)"
                @select="$emit('select', $event)" @delete="$emit('delete', $event)" @image-drop="onImageDrop"
                @label-drop="onLabelDrop" />
        </ul>
    </li>
</template>

<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
    node: Object,
    expanded: Object,
    selectedLabelId: [String, Number, null],
    editable: {
        type: Boolean,
        required: false,
        default: true,
    }
});

const emit = defineEmits(['toggle', 'select', 'delete', 'image-drop', 'label-drop']);

const hasChildren = computed(() => props.node.children && props.node.children.length > 0);
const isDragOver = ref(false);


function onDragStart(e) {
    // Use both for compatibility
    e.dataTransfer.setData('text/plain', String(props.node.id));
    // Optional custom type
    e.dataTransfer.setData('label-id', String(props.node.id));
    // Store the currently dragged label ID for the onDragOver (bug)
    window.currentlyDraggedLabelId = props.node.id;
}


function onDragEnter(e) {
    isDragOver.value = true;
    e.preventDefault();
}

function onDragLeave(e) {
    // Only set to false if we're actually leaving this element (not entering a child)
    if (e.currentTarget.contains(e.relatedTarget)) {
        return;
    }
    isDragOver.value = false;
}

// check if we are over a valid node
function onDragOver(e) {

    const drag_labelId = window.currentlyDraggedLabelId;

    if (drag_labelId) {
        if (drag_labelId === props.node.id) {
            // visual feedback for root node
            e.dataTransfer.dropEffect = 'link';
        } else if (props.node.parentIds.includes(drag_labelId)) {
            e.dataTransfer.dropEffect = 'none';
        } else {
            e.dataTransfer.dropEffect = 'move';
        }
    }else {
            e.dataTransfer.dropEffect = 'move';
        }

    e.preventDefault(); // nodig om drop te laten werken
}

function onDrop(e) {
    isDragOver.value = false;
    const drag_imageId = e.dataTransfer.getData('image-id');
    const drag_labelId = Number(e.dataTransfer.getData('label-id'));
    if (drag_imageId) {
        emit('image-drop', { labelId: props.node.id, imageId: drag_imageId });
    } else if (drag_labelId) {
        if (props.node.parentIds.includes(drag_labelId)) {
            return;
        } else {
            emit('label-drop', { labelId: drag_labelId, parentId: props.node.id });
        }

    }
}

function onImageDrop({ labelId, imageId }) {
    emit('image-drop', { labelId, imageId });
}

function onLabelDrop({ labelId, parentId }) {
    emit('label-drop', { labelId, parentId });
}

function onDeleteLabel() {
    emit('delete', props.node.id);
}

</script>
